
import { CONST_API_NODEJS_URL } from '../constants'

// Get Insights Elements For Tab Service
export const getInsightsElementsForTab = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${CONST_API_NODEJS_URL}/getInsightsElementsForTab`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};


export default {
  getInsightsElementsForTab
}
